
import React, { Component } from 'react';
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import LinearProgress from '@material-ui/core/LinearProgress';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FadeIn from 'react-fade-in';
import Tooltip from '@material-ui/core/Tooltip';

import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: null,
			select_region_service_area: this.props.select_region_service_area
		}
	}
	componentDidMount() {
		this.onLoadData(() => {

		})

	}
	onLoadData = (callback) => {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L_DETAIL, {
			quarter_number: this.props.quarter_number,
			range_point: this.props.range_point,
			select_region_service_area: this.state.select_region_service_area,
		}, ({ datas }) => {
			this.setState({
				data: null
			}, () => {
				this.setState({
					data: datas
				}, () => {
					Alert.LoadingClose()
					callback()
				})
			})
		})
	}
	componentWillUpdate(nextProps, nextState) {
		console.log(nextProps.select_region_service_area, nextState.select_region_service_area)
		if (nextProps.select_region_service_area !== nextState.select_region_service_area) {
			this.setState({
				select_region_service_area: nextProps.select_region_service_area
			}, () => {
				this.onLoadData(() => {
				})
			})

		}

	}
	renderLabelData(index, name, data_os1_count, data_os1_list, data_customer_list = null) {
		return <div>
			<GridContainer
				justify="center"
				className="mouse-hover-list1"
				onClick={e => this.handdleClickList(name, data_customer_list)}
			>
				<GridItem xs={7}>
					<Typography variant="body2" align="left"  >{index}) {name} </Typography>
				</GridItem>
				<GridItem xs={5}>
					<Typography variant="body2" align="right"   >N:{data_os1_count}</Typography>
				</GridItem>
				{/* <GridItem xs={5}>
					<Typography variant="body2" align="left"   >{data_os1_list}</Typography>
				</GridItem> */}
			</GridContainer>
		</div>
	}
	handdleClickList = (name, data_customer_list) => {
		if (data_customer_list.length > 0) {
			var data = {
				level: 3,
				name: name,
				data_customer_list: data_customer_list
			}
			this.props.callbackChangelevel(data)
		}

	}
	renderList = () => {
		var res = []
		for (const key in this.state.data) {
			if (Object.hasOwnProperty.call(this.state.data, key)) {
				const element = this.state.data[key];
				if (element.length != 0) {
					res.push(<h4 className="txt-c-gn"><b>{key} </b></h4>)
					element.map((row, index) => {
						res.push(this.renderLabelData(index + 1, row.name, row.data_os1_count, row.data_os1_list, row.data_customer_list))

					})
				}
			}
		}
		return res
	}
	// renderTooltip = (str) => {
	// 	var _str = str
	// 	// if (str.length > 20) {
	// 	// 	_str = str.substring(0, 20) + "..."
	// 	// }
	// 	return (
	// 		<Tooltip title={str} arrow placement="top">
	// 			<div>{_str}</div>
	// 		</Tooltip>
	// 	)
	// }
	render() {
		return (
			<div className={"p-1 chart-box"}>
				<div >
					<GridContainer justify="center">
						<GridItem xs={6} className="m-b-1">
							<h4 className="m-t-0"><b>{this.props.quarter_name} - {this.props.range_name}</b></h4>
						</GridItem>
						<GridItem xs={6}>
							{/* <div className="W100 txt-r m-b-1">
								<b>% Quarter {this.props.quarter_number == 2 ? "2(current)" : this.props.quarter_number == 1 ? 4 : this.props.quarter_number - 1}</b>
							</div> */}
						</GridItem>
					</GridContainer>
					{
						this.state.data != null ?
							<FadeIn>
								{this.renderList()}
								{/* {this.state.data.map((row, index) => {
									return this.renderLabelData(index + 1, row.name, row.region_name, row.data_os1_count, row.data_os1_list)
								})} */}
							</FadeIn>
							: null
					}
				</div>
			</div>
		);
	}
}

export default Chart;